


















































































































































































































































import MenuBooleanItem from "./MenuBooleanItem.vue";

import { Action } from "vuex-class";
import { Component, Vue } from "vue-property-decorator";
import { StoreUseData } from "@/@types/store";
import { UserData } from "@/@types/room";
import VueEvent from "@/app/core/decorator/VueEvent";
import TaskManager from "@/app/core/task/TaskManager";
import { WindowOpenInfo } from "@/@types/window";
import GameObjectManager from "@/app/basic/GameObjectManager";

@Component({
  components: {
    MenuBooleanItem
  },
  filters: {
    loginNum: (userList: StoreUseData<UserData>[]) =>
      userList.filter(user => user!.data!.login > 0).length
  }
})
export default class Menu extends Vue {
  private roomData = GameObjectManager.instance.roomData;
  @Action("windowOpenDeprecated") private windowOpenDeprecated: any;
  @Action("setPropertyDeprecated") private setPropertyDeprecated: any;
  @Action("doResetWindowLocateDeprecated")
  private doResetWindowLocateDeprecated: any;
  @Action("exportStartDeprecated") private exportStartDeprecated: any;
  @Action("addListObjDeprecated") private addListObjDeprecated: any;
  @Action("saveChatLogHtmlDeprecated") private saveChatLogHtmlDeprecated: any;

  private isConnectHover: boolean = false;
  private isSelecting: boolean = false;
  private currentMenu: string = "";
  private userList: StoreUseData<UserData>[] =
    GameObjectManager.instance.userList;

  public key: string = "menu";

  // @LifeCycle
  // public async mounted() {}

  menuClick(): void {
    this.isSelecting = !this.isSelecting;
  }

  isShow(...props: any[]): any {
    return (
      this.isSelecting && props.filter(prop => prop === this.currentMenu)[0]
    );
  }

  menuHover(prop: string): void {
    this.currentMenu = prop;
  }

  hoverConnect(flg: boolean): void {
    this.isConnectHover = flg;
  }

  /** 部屋情報ボタン押下 */
  @VueEvent
  private async clickRoomInfo(): Promise<void> {
    await TaskManager.instance.ignition<WindowOpenInfo<void>, void>({
      type: "window-open",
      owner: "Quoridorn",
      value: {
        type: "room-info-window"
      }
    });
  }

  /** 共有メモボタン押下 */
  @VueEvent
  private clickPublicMemo() {
    this.addListObjDeprecated({
      propName: "publicMemo",
      kind: "publicMemo",
      targetList: [],
      title: "共有メモ",
      tabList: []
    });
  }

  /** ログアウトボタン押下 */
  @VueEvent
  private clickLogOut(): void {
    location.href = location.href.replace(/\?.+$/, "");
  }

  /* --------------------
   * ファイル
   * ----------------- */
  /** セーブ */
  clickExport(): void {
    this.exportStartDeprecated(true);
    this.menuClick();
  }

  /** ロード */
  clickImport(): void {
    this.setPropertyDeprecated({
      property: "private.display.unSupportWindow.title",
      value: "ロード",
      logOff: true
    });
    this.windowOpenDeprecated("private.display.unSupportWindow");
    this.menuClick();
  }

  /** チャットログ保存 */
  clickChatLog(): void {
    this.saveChatLogHtmlDeprecated();
    this.menuClick();
  }

  /* --------------------
   * 表示
   * ----------------- */
  /** フォントサイズ調整 */
  clickSettingFontSize(): void {
    this.setPropertyDeprecated({
      property: "private.display.unSupportWindow.title",
      value: "フォントサイズ変更",
      logOff: true
    });
    this.windowOpenDeprecated("private.display.unSupportWindow");
    this.menuClick();
  }

  /** ウィンドウ配置初期化 */
  clickResetWindowLocate(): void {
    this.doResetWindowLocateDeprecated();
    this.menuClick();
  }

  /* --------------------
   * コマ
   * ----------------- */
  /** キャラクター追加 */
  clickAddCharacter(): void {
    this.windowOpenDeprecated("private.display.addCharacterSettingWindow");
    this.menuClick();
  }

  /** 範囲追加 */
  clickAddRange(): void {
    this.setPropertyDeprecated({
      property: "private.display.unSupportWindow.title",
      value: "範囲追加",
      logOff: true
    });
    this.windowOpenDeprecated("private.display.unSupportWindow");
    this.menuClick();
  }

  /** チット作成 */
  clickAddChit(): void {
    this.windowOpenDeprecated("private.display.addChitWindow");
    this.menuClick();
  }

  /** 墓場 */
  clickGraveyard(): void {
    alert("「墓場」はプレイヤーボックス画面に統合されました。");
    this.menuClick();
  }

  /** キャラクター待合室 */
  clickWaitingRoom(): void {
    alert("「キャラクター待合室」はプレイヤーボックス画面に統合されました。");
    this.menuClick();
  }

  /* --------------------
   * マップ
   * ----------------- */
  /** マップ変更 */
  clickChangeMap(): void {
    this.windowOpenDeprecated("private.display.editMapWindow");
    this.menuClick();
  }

  /** フロアタイル追加 */
  clickAddFloorTile(): void {
    this.windowOpenDeprecated("private.display.addFloorTileWindow");
    this.menuClick();
  }

  /** マップマスク追加 */
  clickAddMapMask(): void {
    this.windowOpenDeprecated("private.display.addMapMaskWindow");
    this.menuClick();
  }

  /** 簡易マップ作成 */
  clickCreateEasyMap(): void {
    this.setPropertyDeprecated({
      property: "private.display.unSupportWindow.title",
      value: "簡易マップ",
      logOff: true
    });
    this.windowOpenDeprecated("private.display.unSupportWindow");
    this.menuClick();
  }

  /** マップ状態保存 */
  clickSaveMap(): void {
    this.setPropertyDeprecated({
      property: "private.display.unSupportWindow.title",
      value: "マップ保存",
      logOff: true
    });
    this.windowOpenDeprecated("private.display.unSupportWindow");
    this.menuClick();
  }

  /** マップ切り替え */
  clickSwitchMap(): void {
    this.setPropertyDeprecated({
      property: "private.display.unSupportWindow.title",
      value: "マップ切り替え",
      logOff: true
    });
    this.windowOpenDeprecated("private.display.unSupportWindow");
    this.menuClick();
  }

  /* --------------------
   * 画像
   * ----------------- */
  /** ファイルアップローダー */
  clickFileUploader(): void {
    this.windowOpenDeprecated("private.display.fileUploaderWindow");
    this.menuClick();
  }

  /** タグ編集 */
  clickTagEdit(): void {
    this.setPropertyDeprecated({
      property: "private.display.unSupportWindow.title",
      value: "画像タグ編集",
      logOff: true
    });
    this.windowOpenDeprecated("private.display.unSupportWindow");
    this.menuClick();
  }

  /** 画像削除 */
  clickDeleteImage(): void {
    this.setPropertyDeprecated({
      property: "private.display.unSupportWindow.title",
      value: "画像削除",
      logOff: true
    });
    this.windowOpenDeprecated("private.display.unSupportWindow");
    this.menuClick();
  }

  /* --------------------
   * ヘルプ
   * ----------------- */
  /** ようこそ */
  clickWelcome(): void {
    this.windowOpenDeprecated("private.display.welcomeWindow");
    this.menuClick();
  }

  /** バージョン */
  clickVersion(): void {
    this.windowOpenDeprecated("private.display.versionWindow");
    this.menuClick();
  }

  /** マニュアル */
  clickManual(): void {
    this.setPropertyDeprecated({
      property: "private.display.unSupportWindow.title",
      value: "マニュアル",
      logOff: true
    });
    this.windowOpenDeprecated("private.display.unSupportWindow");
    this.menuClick();
  }

  /** オフィシャルサイトへ */
  clickOfficialSite(): void {
    window.open("http://quoridorn.com/", "_blank");
    this.menuClick();
  }

  /* --------------------
   * デモ
   * ----------------- */
  /** 開発履歴 */
  clickDevHistory(): void {
    this.windowOpenDeprecated("private.display.devLogWindow");
    this.menuClick();
  }

  /** 不具合の報告 */
  clickBufForm(): void {
    window.open("https://9224.teacup.com/quoridorn_bug/bbs", "_blank");
    this.menuClick();
  }
}
